import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
const baseApiUrlSearch = 'api/cms-news/search';

import { ICmsNews } from '@/shared/model/cms-news.model';

const baseApiUrl = 'api/cms-news';
const apiUploadFiles = 'api/cms-news/upload-files';
const apiDeleteFile = 'api/cms-news/delete-file';
const apiUploadTitleImage = 'api/cms-news/upload-title-image';
const apiDeleteTitleImage = 'api/cms-news/delete-title-image';

function appendPlatform(url: string, platform?: 'S2B' | 'B2B') {
  if (!platform) return url;
  const needsSep = url.includes('?') ? (url.endsWith('?') || url.endsWith('&') ? '' : '&') : '?';
  return `${url}${needsSep}platform=${encodeURIComponent(platform)}`;
}
export default class CmsNewsService {
  public find(id: number): Promise<ICmsNews> {
    return new Promise<ICmsNews>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any, platform?: string): Promise<any> {
    const params: any = { ...paginationQuery };
    if (platform) {
      params.platform = platform;
    }

    return axios
      .get(baseApiUrl, { params })
      .then(res => res)
      .catch(err => Promise.reject(err));
  }

  public retrieveSearch(search: string, paginationQuery?: any, platform?: string): Promise<any> {
    const params: any = { search, ...paginationQuery };
    if (platform) {
      params.platform = platform;
    }

    return axios
      .get(baseApiUrlSearch, { params })
      .then(res => res)
      .catch(err => Promise.reject(err));
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ICmsNews): Promise<ICmsNews> {
    return new Promise<ICmsNews>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ICmsNews): Promise<ICmsNews> {
    return new Promise<ICmsNews>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public uploadFiles(entity: FormData): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(apiUploadFiles, entity, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public deleteFile(id: number, fileId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${apiDeleteFile}/${id}/${fileId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public uploadTitleImage(entity: FormData): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(apiUploadTitleImage, entity, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public deleteTitleImage(cmsNewsId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${apiDeleteTitleImage}/${cmsNewsId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
